var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"examination"},[_c('Header'),_c('Default'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }